<template>
  <div class="flex-grow relative overflow-y-auto h-full">
    <transition-group
      :enter-active-class="
        animateBack
          ? 'animate__animated animate__slideInLeft animate__faster'
          : 'animate__animated animate__slideInRight animate__faster'
      "
      :leave-active-class="
        animateBack
          ? 'animate__animated animate__slideOutRight animate__faster'
          : 'animate__animated animate__slideOutLeft animate__faster'
      "
    >
      <ul
        class="LeftNav space-y-3 absolute inset-0"
        v-show="openedItems.length === 0"
        key="root"
      >
        <slot></slot>
      </ul>
      <template v-for="stepId in steps" :key="'LeftNavMobileStep' + stepId">
        <ul
          class="LeftNav space-y-3 absolute inset-0"
          :id="'LeftNavMobileStep' + stepId"
          v-show="openedItem?.id === stepId"
        >
          <li class="LeftNav__Item">
            <a
              href=""
              class="pl-5 pr-4 flex items-center text-sm"
              @click.stop.prevent="goBack()"
            >
              <span class="mr-2">
                <aw-icon
                  icon="chevron-left"
                  class="w-4 h-4 "
                ></aw-icon>
              </span>
              <span>{{ openedItem?.title }}</span>
            </a>
          </li>
          <!-- Teleport menu here! -->
        </ul>
      </template>
    </transition-group>
  </div>
</template>

<script>
import { computed } from 'vue'

export default {
  data() {
    return {
      steps: [], // list of steps ids
      openedItems: [],
      animateBack: false
    }
  },
  computed: {
    openedItem() {
      if (this.openedItems.length === 0) return null

      return this.openedItems[this.openedItems.length - 1]
    }
  },
  methods: {
    goBack() {
      this.animateBack = true
      this.openedItems.pop()
    }
  },
  provide() {
    return {
      addNavStep: (id) => {
        if (this.steps.indexOf(id) === -1) {
          this.steps.push(id)
        }
      },
      openNavStep: (title, icon, id) => {
        this.animateBack = false
        this.openedItems.push({ title, icon, id })
      },
      openedNavStepIds: computed(() => {
        return this.openedItems.map((openedItem) => {
          return openedItem.id
        })
      })
    }
  }
}
</script>
